/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {HtmlAttributesDirective as ɵa} from './lib/shared/html-attr.directive';